export default __webpack_public_path__ + "static/graphik-web-medium-a625508f46adb5cb2fcb550cb7a38b55.woff";